<template>
  <div id="app">
    <NavBar v-if="routeNotEmpty == false"></NavBar>
    <router-view />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
export default {
  name: "AppComponent",
  components: {
    NavBar
  },
  mounted() {
    document.title = 'Talki'
  },
  computed: {
    routeNotEmpty() {
      return this.checkIfRoute();
    }
  },
  methods: {
    checkIfRoute() {
      return this.$route.name === 'login' || this.$route.name === 'register' || this.$route.name == 'not-found' || this.$route.name == 'terms' || this.$route.name == 'delete';
    }
  },
};
</script>

<style>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css');
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

:root {
  --grey: #ccc;
  --light-grey: #fafafa;
  --another-grey: #9c9c9c;
  --not-so-grey: #ebecec;
  --main-color: #FFCA53;
  --red: #ff0000;
  --white: #fff;
  --black: #000;
  --secondary-color: #FE4885;
  --darker-main-color: #a08444;
}

body {
  margin: 0;
}

#app {
  font-family: "Poppins", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>
